import {
    CopyObjectCommand,
    DeleteObjectCommand,
    PutObjectCommand,
    S3Client,
} from "@aws-sdk/client-s3"

const s3Client = new S3Client()

export const copyS3Object = async (
    sourceBucket: string,
    sourceKey: string,
    destinationBucket: string,
    destinationKey: string
) => {
    await s3Client.send(
        new CopyObjectCommand({
            CopySource: `${sourceBucket}/${sourceKey}`,
            Bucket: destinationBucket,
            Key: destinationKey,
        })
    )

    return { bucket: destinationBucket, key: destinationKey }
}

export const deleteS3Object = async (bucket: string, key: string) => {
    await s3Client.send(
        new DeleteObjectCommand({
            Bucket: bucket,
            Key: key,
        })
    )
}

export const putS3Object = async (
    bucket: string,
    key: string,
    body: string,
    contentType?: string
) => {
    await s3Client.send(
        new PutObjectCommand({
            Bucket: bucket,
            Key: key,
            Body: body,
            ContentType: contentType,
        })
    )
}
